import type { PresetAvatarOption } from '../services/preset-avatar-loader';
export function AvatarPicker({ options, selectedId, onSelect }: { options: PresetAvatarOption[]; selectedId: string | null; onSelect: (id: string) => void }) {
	return (
		<div role="listbox" aria-label="Preset avatars" className="hud-toolbar">
			{options.map((option) => (
				<button className="hud-chip" role="option" aria-selected={selectedId === option.presetAvatarId} key={option.presetAvatarId} onClick={() => onSelect(option.presetAvatarId)} type="button">
					{option.tags.join(' ')}
				</button>
			))}
		</div>
	);
}
